module.exports = __webpack_public_path__ + "images/help/icon-twr58@2x-b0c53e9f64c7741e054b19fabfa22d7e.png";